import { Col, Row } from 'antd';
import React from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import StemHighlights from './StemHighlights';
import useLocalization from '../../../Localization';

const StemOutReachComponent = ({ stemData }) => {
  const { ApplicationString } = useLocalization();
  const StemComponentHTML = stemData?.stem;
  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRow'>
        <Col span={24}>
          <SponsorOptionPageHeroText
            title={ApplicationString['stemOutreachComponent.title']}
            subTitle={ApplicationString['pbss.generalInformation.subtitle']}
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <div dangerouslySetInnerHTML={{ __html: StemComponentHTML }}></div>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <StemHighlights data={stemData} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default StemOutReachComponent;
